<template>
  <div :class="['content', programStyle]">
    <div
      v-if="mostRecentStatus && mostRecentStatus.result && mostRecentStatus.result !== 'Submitted'"
      class="review-container"
    >
      <div :class="['result-container', mostRecentStatus.result === 'Declined' ? 'red' : 'green']">
        {{ mostRecentStatus.result }}
      </div>
    </div>
    <div class="title-container">
      <div v-if="formName === 'Proof of Door Dimension'" class="title">DOOR DIMENSION</div>
      <div v-else class="title">CEILING HEIGHT</div>
    </div>
    <div v-if="mostRecentStatus && mostRecentStatus.reason" class="reason-container">
      <h4 class="label">Reason:</h4>
      <h4 class="reason-box">{{ mostRecentStatus.reason }}</h4>
    </div>
    <div class="form-container">
      <div class="item-container" v-for="(appeal, index) in appeals" :key="appeal.dialId">
        <div class="dial-info" :class="[appealType === 'view' ? 'view-form' : '']">
          <div class="left-container flex-row">
            <div v-if="index === 0" :class="['circle', appeal.dialColor]">
              <div class="inner" v-if="appeal.dialResultText">
                {{ appeal.dialResultText }}
              </div>
            </div>
          </div>
          <div class="right-container flex-column">
            <div v-if="index === 0" class="title-small">
              * {{ formName }}<span v-if="formName === 'Proof of Door Dimension'"></span>
            </div>
            <h4>
              You must upload photos of <u><b>ALL</b></u> the following:
            </h4>
            <h4 v-if="formName === 'Proof of Door Dimension'">Proof of Door Dimensions 13ft. High and 10ft. Wide</h4>
            <ol>
              <li v-if="formName === 'Proof of Door Dimension'">
                Photo from exterior of entire service door with a Stellantis vehicle in frame for reference.
              </li>
              <li v-else>Photo of the service bay with a Stellantis vehicle in frame for reference.</li>
            </ol>
          </div>
        </div>
        <div class="upload-container">
          <Upload
            :class="[validationCheck && !uploadsValidation ? 'uploads-required' : '']"
            v-if="!appeal.uploads"
            :appeal="appeal"
            v-on:sendurl="getUrl"
            @removeUpload="removeUpload"
          />
          <div v-if="validationCheck && !uploadsValidation" class="helper-text_error">
            <h4>You must upload photos/documentation.</h4>
          </div>
          <div v-if="appeal.uploads">
            <h4 class="title">{{ $t('supporting-documents-0') }}</h4>
            <div class="support-docs" v-for="upload in appeal.uploads" :key="upload.key">
              <span v-if="upload.dialId === appeal.dialId">{{ upload.originalFilename }}</span>
              <a v-if="upload.dialId === appeal.dialId" class="relative" target="_blank" :href="upload.url">
                <img class="download-icon" src="@/assets/img/download-arrow.png" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom-container flex-column">
        <div class="form-details flex-column">
          <h4 class="note">
            Note: After <span id="form-name">{{ formName }}</span
            ><span v-if="formName === 'Proof of Door Dimension'">s</span> has been uploaded, it will be reviewed by
            Stellantis. When the review is complete, the associated pillar dial will be updated the next business day.
          </h4>
        </div>
        <div class="button-container flex-row">
          <button
            class="submit-button"
            :class="[submitValidation ? '' : 'disabled']"
            v-if="!viewForm"
            @click="submitForm"
          >
            {{ $t('submit') }}
          </button>
          <button class="exit-button" v-if="!viewForm" @click="isModalOpen = true">{{ $t('exit') }}</button>
          <button class="exit-button" v-if="viewForm" @click="exit">{{ $t('exit') }}</button>
        </div>
      </div>
    </div>
    <Modal class="modal-screens" v-show="isModalOpen">
      <template v-slot:body class="body">
        <div class="modal-content">
          <span class="modal-title">Confirm Cancellation?</span>
          <span class="modal-text"
            >You are cancelling this request. This action cannot be undone. Are you sure you want to confirm your
            cancellation?</span
          >
        </div>
        <div class="modal-button-container">
          <button class="submit" @click="exit">Confirm</button>
          <button class="cancel-button" @click="isModalOpen = false">{{ $t('cancel') }}</button>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import Upload from '@/components/Upload.vue';
import Modal from '@/components/Modal.vue';
import { mapState } from 'vuex';

export default {
  name: 'AcknowledgementUSPM',
  components: { Upload, Modal },
  props: {
    appealType: {
      type: String,
      required: true,
    },
    config: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      appeals: [],
      uploads: [],
      isModalOpen: false,
      formName: null,
    };
  },
  methods: {
    setFormName() {
      if (this.otherAppealInfo) {
        this.formName = this.otherAppealInfo.layout;
      } else {
        this.formName = this.config.layout;
      }
    },
    dateFilter(value, filter) {
      if (value && filter && this.$options.filters[filter]) {
        return this.$options.filters[filter](value);
      }
      return value;
    },
    getComplexFormSupplementalData() {
      const loader = this.$loading.show();

      const { domain, entity } = this;

      let formId = '';
      if (this.appealType === 'submit') {
        formId = 'new';
      } else {
        const id = this.selectedForm[0].formId;
        formId = id;
      }

      this.$store
        .dispatch('getComplexFormSupplementalData', { formId, domain, entity })
        .then((res) => {
          this.vendor = res.vendor;
          this.date = res.date;
        })
        .catch((error) => {
          if (error.data) {
            this.$notify({
              group: 'primary',
              type: 'error',
              text: error.data.error,
            });
          }
        })
        .finally(() => {
          loader.hide();
        });
    },
    submitForm() {
      const loader = this.$loading.show();

      const items = [];

      const { domain, entity, uploads } = this;

      this.appeals.forEach((appeal) => {
        items.push(appeal);
      });

      const params = {
        domain,
        entity,
        items,
        uploads,
        status: 'submit',
        type: this.config.formType,
        layout: this.config.layout,
        result: 'Submitted',
        configId: this.config.id,
      };

      this.$store
        .dispatch('submitForm', params)
        .then(() => {
          this.$notify({
            group: 'primary',
            type: 'success',
            text: 'Form Successfully Submitted!',
          });
          this.validationCheck = false;
          this.exit();
        })
        .catch((error) => {
          if (error.data) {
            this.$notify({
              group: 'primary',
              type: 'error',
              text: error.data.error,
            });
          }
        })
        .finally(() => {
          loader.hide();
        });
    },
    exit() {
      this.$router.push({
        name: 'Dealer-Forms',
      });
    },
    getUrl(res) {
      const upload = {
        adjustedFilename: res.res.data.fileInfo.adjustedFilename,
        originalFilename: res.res.data.fileInfo.originalFilename,
        label: res.appeal.dialTitle,
        dialId: res.appeal.dialId,
      };
      this.uploads.push(upload);
    },
    getAppeals() {
      this.setFormName();
      if (this.appealType === 'view') {
        this.appeals = JSON.parse(JSON.stringify(this.selectedForm));
        this.getComplexFormSupplementalData();
        this.isAcknowledged = true;
      } else {
        let name = '';
        if (this.formName === 'Proof of Door Dimension') {
          name = '* PROOF OF DOOR DIMENSION';
        } else {
          name = '* PROOF OF CEILING HEIGHT';
        }
        this.appeals = [
          {
            dialColor: 'N',
            dialId: '0',
            dialResultText: '',
            dialTitle: name,
          },
        ];
      }
    },
    removeUpload(selectedFile) {
      this.uploads.forEach((file, index) => {
        if (file.originalFilename === selectedFile.file) {
          this.uploads.splice(index, 1);
        }
      });
    },
  },
  computed: {
    ...mapState('global', ['programStyle', 'programName']),
    ...mapState(['selectedForm', 'otherAppealInfo']),
    entity() {
      return this.$route.params.entity;
    },
    domain() {
      return this.$route.params.domain;
    },
    mostRecentStatus() {
      if (this.otherAppealInfo) {
        return this.otherAppealInfo.statuses[0];
      }
      return null;
    },
    viewForm() {
      return this.appealType === 'view';
    },
    uploadsValidation() {
      return this.uploads.length > 0;
    },
    submitValidation() {
      return this.uploads.length > 0;
    },
  },
  watch: {},
  created() {
    this.getAppeals();
  },
  beforeDestroy() {
    this.$emit('exit');
  },
};
</script>

<style lang="scss" scoped>
.content {
  color: #000000;
  text-align: left;
  .link {
    color: #243882;
  }
  padding: 30px 30px 45px;
  input:focus {
    outline: none;
  }
}
.title {
  color: #243882;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  text-transform: uppercase;
  margin-bottom: 30px;
}
.title-small {
  font-size: 14px;
}
h4 {
  font-size: 14px;
  font-weight: normal;
  text-transform: none;
  &.title {
    margin-top: 0px !important;
  }
}
ol {
  margin: 0px;
  padding-left: 15px;
  li {
    font-size: 14px;
    font-weight: normal;
    text-transform: none;
  }
}
.reason-container {
  .label {
    font-size: 14px;
    font-weight: bold;
    line-height: 20px;
    text-transform: uppercase;
    margin-bottom: 20px;
  }
  .reason-box {
    padding: 20px;
    border: 1px solid $border;
    min-width: 600px;
    margin: 0px;
  }
}
.item-container {
  margin-top: 30px;
  .dial-info {
    display: flex;
    margin-bottom: 30px;
  }
  .view-form {
    background-color: #f5f7f8;
    padding: 35px;
    margin: 30px -30px;
  }
}
.right-container {
  font-size: 14px;
  font-weight: bold;
  line-height: 20px;
  text-transform: uppercase;
  input {
    height: 100px;
    width: initial;
    background: $input-background;
    border: none;
    margin-bottom: 20px;
  }
  .item {
    display: flex;
    flex-direction: column;
  }
  h4 {
    margin: 0px;
  }
}
.upload-container {
  font-size: 14px;
  .title {
    font-size: 14px;
    color: $primary-black;
    font-weight: bold;
    line-height: 20px;
    text-transform: uppercase;
    margin: 0px;
  }
  .support-docs {
    display: flex;
    align-items: center;
  }
}
.left-container {
  min-width: 80px;
  align-items: center;
  margin-right: 20px;
}
.subtitle {
  font-size: 14px;
  margin-bottom: 10px;
  font-weight: normal;
  text-transform: none;
}
.bottom-container {
  font-size: 14px;
  line-height: 20px;
  span {
    margin-bottom: 20px;
  }
  span:last-child {
    margin-bottom: 0px;
  }
}
.button-container {
  margin-top: 45px;
  align-items: center;
  justify-content: flex-start;
  button {
    margin-right: 15px;
  }
  button:hover {
    text-decoration: underline;
  }
  .exit-button {
    background-color: $primary-white;
    border: 1px solid $primary;
    color: $primary;
  }
}
.helper-text {
  font-size: 14px;
  color: $primary-black;
  &_success {
    color: #008716 !important;
    span {
      color: #008716 !important;
      font-size: 14px !important;
    }
  }
  &_error {
    color: $error !important;
    h4 {
      color: $error !important;
      font-size: 14px !important;
      line-height: 20px !important;
      margin: 15px 0px 0px !important;
      text-transform: none;
    }
  }
  &_notify {
    color: $primary-black;
    opacity: 0.5 !important;
    font-size: 14px !important;
  }
}
.required {
  border: 1px solid red !important;
}
button {
  &.disabled {
    pointer-events: none;
  }
}
button:hover {
  text-decoration: underline;
}
.note {
  margin: 30px 0px 0px;
}
#form-name {
  text-transform: lowercase;
}
::v-deep {
  .filter {
    width: 254px !important;
    border: none !important;
  }
  .collapsible {
    padding-right: 0px !important;
  }
}
.modal-body {
  display: flex;
  flex-direction: column;
  .close {
    display: flex;
    justify-content: flex-end;
    svg {
      height: 30px;
      width: 30px;
      cursor: pointer;
    }
  }
  .modal-content {
    width: 100%;
    text-align: center;
  }
  .modal-title {
    font-size: 20px;
    line-height: 26px;
    color: $primary;
    text-transform: uppercase;
    font-weight: bold;
    display: block;
    margin-bottom: 20px;
  }
  .modal-text {
    font-size: 14px;
    line-height: 20px;
    color: $primary-black;
    display: block;
  }
  .modal-button-container {
    display: flex;
    margin-top: 35px;
    justify-content: center;
    .submit {
      margin-right: 20px;
    }
    .cancel-button {
      background-color: #ffffff;
      border: 1px solid #243882;
      color: #243882;
    }
  }
}
</style>
